import React, { memo } from 'react';
import DotField from './DotField';

const MemoizedDotField = memo(() => (
	<div className="absolute inset-0 viewport-height-no-header h-full w-full opacity-100  pointer-events-none">
		<div style={{ width: '100%', height: '100%', position: 'relative' }}>
			<DotField
				dotRadius={1.5}
				dotSpacing={14}
				cursorRadius={500}
				cursorForce={0.1}
				bulgeOnly
				bulgeStrength={67}
				glowRadius={160}
				sparkle={false}
				waveAmplitude={0}
				gradientFrom="#37bede"
				gradientTo="#120A86"
				glowColor="#1D7B9038"
			/>
		</div>
	</div>
));

type Props = { children: React.ReactNode; className?: string };

export default function DotFieldBackground({ children, className }: Props) {
	return (
		<div className={`relative isolate bg-[#101010] ${className ?? ''}`}>
			<MemoizedDotField />
			<div className={`relative z-10 `}>{children}</div>
		</div>
	);
}
